<template>
  <div ref="echart01" style="width:100%; height:220px;"></div>
</template>

<script>
export default {
  props:{
    datalrtj:{type: Array}
  },
  mounted() {
    let chart01 = this.$echarts.init(this.$refs.echart01)
    var data = this.datalrtj;
    // var data = [
    //   {
    //     name: '当年成本',
    //     value: 165132132
    //   },
    //   {
    //     name: '当年收入',
    //     value: 135132115
    //   }
    // ]
    let option={}
    if (data.length == 0 ) {  //暂无数据
      option = {
        title: {
          text: '暂无数据',
          x: 'center',
          y: 'center',
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal',
          }
        }
      }
    } else {
      option = {
        color: ['rgba(253,130,45)', 'rgba(50, 199, 107 )', 'rgba(253,212,104)', 'rgba(27,122,247)', 'rgba(169, 174, 252)', 'rgba(82, 165, 252)'],
        // backgroundColor: '#0f375f',
        // title: {
        //   text: 7789,
        //   subtext: '总计',
        //   textStyle: {
        //     color: '#000',
        //     fontSize: 10
        //   },
        //   subtextStyle: {
        //     fontSize: 10,
        //     color: ['#000']
        //   },
        //   x: '45%',
        //   y: '55%'
        // },
        grid: {
          top: 0,
          bottom:'20%',
          containLabel:true
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/> {c}万元  ({d}%)'
        },
        legend: {
          backgroundColor: 'rgba(242, 248, 255)',
          top: 0,
          textStyle: {
            color: '#000',
            fontSize: 12
          },
          icon: 'roundRect',
          data: data
        },
        series: [
          // 主要展示层的
          {
            radius: ['0%', '50%'],
            center: ['50%', '50%'],
            type: 'pie',
            label: {
              position: 'outside',
              formatter: '{b}：{c}万元'
            },
            labelLine: {
              normal: {
                show: true,
                length: 5,
                length2: 5
              },
              emphasis: {
                show: true
              }
            },
            data: data
          },

        ]
      }
    }

    chart01.setOption(option, true)
  }
}
</script>

<style></style>
